import { futureValueSIP } from "../../engine/calculations";

const config = {
  key: "term-plus-sip",
  title: "Term Insurance + SIP",
  category: "Insurance & Protection",
  description: "See a pure term cover's premium and a separate SIP's growth, side by side.",
  fields: [
    { key: "cover", label: "Term cover amount", type: "currency", default: 1_00_00_000, min: 1_00_000, max: 10_00_00_000 },
    { key: "termPremium", label: "Annual term premium", type: "currency", default: 12_000, min: 500, max: 10_00_000 },
    { key: "sipAmount", label: "Monthly SIP amount", type: "currency", default: 10_000, min: 500, max: 10_00_000 },
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
    { key: "years", label: "Years", type: "number", default: 20, min: 1, max: 40 },
  ],
  chart: {
    type: "line",
    xKey: "year",
    series: [
      { key: "invested", label: "Invested", colorVar: "--muted" },
      { key: "value", label: "SIP Value", colorVar: "--gold" },
    ],
  },
  compute(values) {
    const cover = Number(values.cover) || 0;
    const termPremium = Number(values.termPremium) || 0;
    const sipAmount = Number(values.sipAmount) || 0;
    const annualRate = (Number(values.returnRate) || 0) / 100;
    const years = Number(values.years) || 0;

    const sipFV = futureValueSIP(sipAmount, annualRate, years * 12);
    const totalPremiumPaid = termPremium * years;
    const totalInvested = sipAmount * years * 12;

    const series = [];
    for (let y = 1; y <= years; y++) {
      series.push({ year: y, invested: sipAmount * y * 12, value: futureValueSIP(sipAmount, annualRate, y * 12) });
    }

    return {
      headline: { label: "SIP Future Value", value: sipFV },
      extraHeadlines: [{ label: "Term cover in force", value: cover }],
      breakdown: [
        { label: "Total term premiums paid", value: totalPremiumPaid },
        { label: "Total SIP invested", value: totalInvested },
        { label: "SIP gains", value: sipFV - totalInvested },
      ],
      series,
    };
  },
};

export default config;
